module.exports = __webpack_public_path__ + "img/settings_filled_64.40ada7af.svg";